var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStop = function SvgStop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8D0C5",
    d: "M19.8 0H8.201L0 8.202v11.597L8.202 28h11.597L28 19.8V8.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    d: "M4.883 11.2c.463 0 .88.178 1.215.477l.2-.093v-.253h.844v1.929h-.727c-.326-.852-.988-1.199-1.532-1.199-.517 0-.807.263-.807.6 0 .412.326.515.752.627l1.162.347c.779.215 1.36.655 1.36 1.48 0 1.001-.643 1.685-1.76 1.685-.526 0-1.07-.234-1.405-.543l-.191.122v.29H3.15v-2.164h.726c.317.984 1.116 1.434 1.715 1.434.598 0 .852-.31.852-.759 0-.421-.345-.562-.644-.646l-1.16-.328c-.862-.244-1.47-.58-1.47-1.517 0-.88.68-1.489 1.714-1.489zm8.067 0v2.574h-.886v-1.356l-.346-.354h-.732v3.518l.347.353h1.097v.865H8.57v-.865h1.097l.347-.353v-3.518h-.732l-.347.354v1.356H8.05V11.2h4.9zm3.15 0c1.498 0 2.45 1.236 2.45 2.8 0 1.564-.952 2.8-2.45 2.8-1.498 0-2.45-1.236-2.45-2.8 0-1.564.952-2.8 2.45-2.8zm6.436 0c1.523 0 2.314.57 2.314 1.621 0 1.072-.791 1.621-2.314 1.621h-1.062v1.14l.36.353h1.252v.865H19.25v-.865h.931l.36-.353v-3.164l-.36-.353h-.931V11.2h3.286zm-6.436.9c-.99 0-1.46.851-1.46 1.9s.47 1.901 1.46 1.901 1.46-.852 1.46-1.9c0-1.05-.47-1.901-1.46-1.901zm6.415-.035h-1.041v1.513h1.041c.932 0 1.283-.285 1.283-.757 0-.472-.35-.756-1.283-.756z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stop.94ceaad5.svg";
export { ForwardRef as ReactComponent };